module.exports = __webpack_public_path__ + "img/SketchPngf2db7c42f34aa1f79b8c9e6e04312472a62b4addcd6eb63d18c15a884d991545.ac2c0bca.png";